<!-- Tight Layout without margin -->
<template>
  <section class="grid h-screen place-items-center">
    <slot />
  </section>
</template>
